import React from 'react'

import * as style from './Testimonial.module.css'

const Component = ({ person, title, url, children }) => {
  const capitalize = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1)

  const urlToName = (url) => capitalize(url.replace(/^https?:\/\//, ''))

  const nameToImageStyle = (name) => {
    const simpleName = name
      .replaceAll(' ', '')
      .replaceAll('ą', 'a')
      .replaceAll('ć', 'c')
      .replaceAll('ę', 'e')
      .replaceAll('ł', 'l')
      .replaceAll('ń', 'n')
      .replaceAll('ó', 'o')
      .replaceAll('ś', 's')
      .replaceAll('ż', 'z')
      .replaceAll('ź', 'z')
      .replaceAll('Ą', 'A')
      .replaceAll('Ć', 'C')
      .replaceAll('Ę', 'E')
      .replaceAll('Ł', 'L')
      .replaceAll('Ń', 'N')
      .replaceAll('Ó', 'O')
      .replaceAll('Ś', 'S')
      .replaceAll('Ż', 'Z')
      .replaceAll('Ź', 'Z')
      .replace(/[^a-zA-Z_]/, '')

    return `personPhoto${simpleName}`
  }

  return (
    <div className={style.testimonial}>
      <div className={style[nameToImageStyle(person)]}></div>
      <div className={style.quoteContainer}>
        <b>
          <p>{children}</p>
        </b>
        <small>
          — {person}, {title}, <a href={url}>{urlToName(url)}</a>
        </small>
      </div>
    </div>
  )
}

export default Component
